module.exports = __webpack_public_path__ + "static/media/youtube-orange.249cf0bc.svg";